<template>
  <div class="card shadow">
    <div class="card-header border-0 dark">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">
            Lista de Ordenes
          </h3>
          <br>
          <base-checkbox v-model="missing">Listar ordenes con pendientes</base-checkbox>
        </div>
        <div class="col text-right">
          <base-button type="success btn_submit" @click="ShowUpdateMasivo">
            Actualizar masivamente estado de ordenes
          </base-button>
          <base-button type="success btn_info" @click="ShowOrderDespachador">
            Asignar Despachador
          </base-button>
          <base-button type="primary btn_create" @click="ShowOrder">
            Crear Orden
          </base-button>
          <create-order/>
          <modal-order-update></modal-order-update>
          <modal-order-despachador/>
        </div>
      </div>
    </div>
    <div class="div list-orders">
      <div class="row">
        <div class="col-4"></div>
        <div class="col-4">
        </div>
      </div>
      <div v-for="(order,index) in orders" :key="index" class="order">
        <div class="row">
          <div class="col-3">
            <H2 class="sub_title">Orden # {{ order.order_id }}</H2>
            <h4 class="sub_title_content" v-if="order.Restaurant != null">Restaurante:
              <span>{{ order.Restaurant.name }}</span></h4>
            <h4 class="sub_title_content" v-if="order.User.length > 0">Usuarios:
              <div v-for="(u,i) in order.User" :key="i">
                <span v-if="u.user_type_id.user_type_id != 6">{{
                    u.user_type_id.user_type_name + ' - ' + u.name + ' ' + u.last_name
                  }}</span>
              </div>
            </h4>
          </div>
          <div class="col-3">
            <h4 class="sub_title_content" v-if="order.shipping_amount != null">Valor envio:
              <span>${{ formatPrice(order.shipping_amount) }}</span></h4>
            <h4 class="sub_title_content" v-if="order.total_sale != null">Valor Compra: <span>${{
                formatPrice(order.total_sale +
                    order.tax_amount)
              }}</span></h4>
            <h4 class="sub_title_content" v-if="order.total_sale != null">Total a pagar:
              <span>${{ formatPrice(order.total_sale + order.tax_amount + order.shipping_amount) }}</span></h4>
          </div>
          <div class="col-3" v-if="order.Paymethod != null">
            <div v-for="(item,i) in order.Paymethod" :key="i">
              <h4 class="sub_title_content">Forma de pago: <span>{{ item.payment_name }}</span></h4>
            </div>
            <h4 class="sub_title_content">Fecha orden: <span>{{ formatedate(order.order_date) }}</span></h4>
            <h4 class="sub_title_content">Hora orden: <span>{{ formatehora(order.order_date) }}</span></h4>
          </div>
          <div class="col-3 row" >
            <div class="col-12" v-if="order.OrderStatus != null">Estado: {{ order.OrderStatus.status }}</div>

            <div class="col-12" v-if="IsMissing(order)"><h4>Orden con pendientes</h4></div>
            <div class="col-12"><h4>Auditada {{ Audit(order.orderproduct) }} % </h4></div>
            <div class="col-12"><base-button size="sm" type="default" outline @click="DetailOrder(order)">Ver Orden
            </base-button></div>

          </div>
        </div>
      </div>
    </div>
    <div>
      <base-pagination align="center" v-model="value" :page-count="page_count"></base-pagination>
    </div>
  </div>
</template>

<script>
import {bus} from "./bus-order"
//import DetailOrder from "./DetailOrder";
import CreateOrder from "./CreateOrder";
import _ from "lodash";
import swal from 'sweetalert';
import {order_service} from '../../services/order/OrderService'
import ModalOrderUpdate from "@/components/Order/ModalOrderUpdate";
import ModalOrderDespachador from "@/components/Order/ModalOrderdespachador";

export default {
  name: "ShowOrder",
  components: {ModalOrderDespachador, ModalOrderUpdate, CreateOrder},
  data() {
    return {
      missing: false,
      page_count: 0,
      orders: [],
      status: [],
      productsku: [],
      searchorder: '',
      value: 1,
      buscador: ''
    }
  },
  watch: {

    'searchorder': function () {
      let data = {'search': this.searchorder}
      if (this.missing) {
        data = {missing: this.missing, search: this.searchorder}
      }
      order_service.GetAllOrderSearch(data)
    },
    'missing': function () {
      let data = {missing: this.missing, search: this.searchorder}
      order_service.GetAllOrderSearch(data)
    },
    'value': function () {
      if (this.buscador !== '') {
        let data = {
          page: (this.value * 10) - 10,
          search: this.buscador
        }
        if (this.missing) {
          data = {
            missing: this.missing,
            page: (this.value * 10) - 10,
            search: this.buscador
          }
        }
        order_service.GetAllOrderPaginationSearch(data)
      } else {
        let data = {
          page: (this.value * 10) - 10
        }
        if (this.missing) {
          data = {
            missing: this.missing,
            page: (this.value * 10) - 10,
          }
        }
        order_service.GetAllOrderPagination(data)
      }

    }
  },
  methods: {
    ShowUpdateMasivo() {
      bus.ShowUpdateMasivo()
    },
    ShowOrderDespachador() {
      bus.ShowOrderDespachador()
    },
    DetailOrder(order) {
      bus.ShowDetailOrder(order)

    },
    parsearr(arr) {
      return JSON.parse(arr)
    },
    IsMissing(order) {

      const pending = _.filter(order.orderproduct, ['is_missing', true]);

      if (pending.length > 0) {
        return true
      } else {
        return false
      }
    },
    Audit(products) {
      let itemsAudited = 0
      let items = products.length
      if (products.length > 0){
        _.each(products, (o) => {
          if (o.audit) {
            itemsAudited += 1
          }
        })
      }else{
        return 0;
      }

      return ((itemsAudited * 100) / items).toFixed(2)

    },
    changestatus(order_status_id, order_id) {

      swal("¿Seguro que va cambiar el estado de la orden?", {
        buttons: {
          cancel: "Cancelar",
          Aceptar: true,
        },
      })
          .then((value) => {
            switch (value) {

              case "Aceptar":
                this.updateorder.order_id = order_id
                this.updateorder.OrderStatus.order_status_id = order_status_id
                order_service.UpdateOrderStatus(this.updateorder)
                break;
              default:
                swal("No se hicieron cambios");

            }
          });

    },
    formatedate(fecha) {
      var fechas = new Date(fecha)
      return fechas.toLocaleDateString()
    },
    formatehora(fecha) {
      var fechas = new Date(fecha)
      return fechas.toLocaleTimeString()
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    ShowOrder() {
      bus.ShowOrder()
    },
    GetNameSku(product_id_sku) {
      const u = _.find(this.productsku, function (item) {
        if (item.sku_product_id === Number(product_id_sku)) {
          return item
        }
      })
      const arr = u
      if (typeof (arr) === 'undefined') {
        return 'N/A'
      } else {
        for (const prop in arr) {
          if (prop === 'name') {
            return arr[prop]
          }
        }
      }
    },
    GetSku(product_id_sku) {
      const u = _.find(this.productsku, function (item) {
        if (item.sku_product_id === Number(product_id_sku)) {
          return item
        }
      })
      const arr = u
      if (typeof (arr) === 'undefined') {
        return 'N/A'
      } else {
        for (const prop in arr) {
          if (prop === 'sku') {
            return arr[prop]
          }
        }
      }
    }
  },

  created() {
    bus.$on('ResponseCreateOrder', (response) => {
      if (response) {
        this.missing = false
      }
    })
    bus.$on('GetAllOrder', (response, value) => {
      this.orders = _.orderBy(response, ['order_id'], ['desc']);
      this.page_count = Math.ceil(value / 10)
      this.value = 1
      this.buscador = ''
    })
    bus.$on('GetAllOrderSearch', (response, value) => {
      this.orders = _.orderBy(response, ['order_id'], ['desc']);
      this.page_count = Math.ceil(value / 10)
      this.value = 1
    })
    bus.$on('Buscador', (response) => {
      this.buscador = response
    })
    bus.$on('GetAllOrderPagination', (response) => {
      this.orders = _.orderBy(response, ['order_id'], ['desc']);
    })
    bus.$on('GetAllProductSku', (response) => {
      this.productsku = _.orderBy(response, ['order_id'], ['desc']);
    })

    bus.$on('ResponseUpdateOrderStatus', (response) => {
      if (response.status === 200) {
        order_service.GetAllOrder()
        swal({
          icon: "success",
          text: "Se Actualizo El Estado De La Orden Correctamente",
          button: "Aceptar"
        })
      } else {
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Se Actualizo El Estado De La Orden Correctamente",
          button: "Aceptar"
        })
      }
    })
  }
}
</script>

<style scoped>
.list-orders {
  padding-left: 20px;
}
</style>
